/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Bottom_Center_LabelInputs */



/**
* | output |
* | --- |
* | "Bottom Center" |
*
* @param {Style_Guide_Manager_Position_Bottom_Center_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_bottom_center_label = /** @type {((inputs?: Style_Guide_Manager_Position_Bottom_Center_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Bottom_Center_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bas centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte unten")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro inferior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("底部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下中央")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निचला बीच का")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro inferior")
	return /** @type {LocalizedString} */ ("Bottom Center")
});